export default function MenuItem(theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          whitespace: "normal",
          // margin: "4px",
          borderRadius: "8px",
          "&:hover": {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
        },
      },
    },
  };
}
